import { FilePenLine, MoreVertical, Inbox, RefreshCw } from '@/components/icons'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'

interface AircraftActionsSelectProps {
  isArchived?: boolean
  onEdit: () => void
  onArchive: () => void
  onUnarchive: () => void
}

export function AircraftActionsSelect({
  isArchived,
  onEdit,
  onArchive,
  onUnarchive,
}: AircraftActionsSelectProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="size-8 p-0 bg-content-primary-inverse hover:bg-content-primary-inverse/30 border-0 rounded-full flex items-center justify-center outline-none">
        <MoreVertical className="size-4 text-content-primary-bold" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {isArchived ? (
          <DropdownMenuItem onClick={onUnarchive}>
            <RefreshCw className="size-4" />
            Unarchive Aircraft
          </DropdownMenuItem>
        ) : (
          <>
            <DropdownMenuItem onClick={onEdit}>
              <FilePenLine className="size-4" />
              Edit Aircraft
            </DropdownMenuItem>
            <DropdownMenuItem variant="destructive" onClick={onArchive}>
              <Inbox className="size-4" />
              Archive Aircraft
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
